// src/components/GoldenCoinIcon.jsx

import React from 'react';

const GoldenCoinIcon = ({ size = 48 }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="goldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#FFA500', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <circle cx="12" cy="12" r="10" fill="url(#goldGradient)" stroke="#DAA520" strokeWidth="1.5" />
      <path 
        d="M12 4L13.06 8.94L18 10L13.06 11.06L12 16L10.94 11.06L6 10L10.94 8.94L12 4Z" 
        fill="white" 
        opacity="0.9"
      />
    </svg>
  );
};

export default GoldenCoinIcon;